import { TableCellComponentProps } from '@/shared/types/table';
import { cn } from '@/shared/utils/cn';
import { Dropdown } from '@/modules/Dropdown';
import {
  getTableCellClasses,
  getTableCellProps,
  handleCellClick,
  getContentAlignClass,
  isFlexColumn,
} from '../../utils/cellStyles';

export const DropdownCell = ({
  value,
  state = 'default',
  onChange,
  className,
  column,
  onCellFocus,
  stickyLeft = 0,
  isLastLocked = false,
  isRowEditing,
  hasColumnMaxWidthAuto = false,
}: TableCellComponentProps) => {
  // Detectar si está en modo edición (si el estado es 'selected' y la columna es editable)
  const isEditing = state === 'selected' && column.editable && column.editable !== 'none';
  const baseClasses = getTableCellClasses(
    state,
    className,
    column.locked,
    isLastLocked,
    isEditing,
    isRowEditing,
    false,
    column.width !== undefined || isFlexColumn(column, hasColumnMaxWidthAuto),
  );
  const cellProps = getTableCellProps(column, stickyLeft, undefined, false, hasColumnMaxWidthAuto);

  // Alineamiento del contenido
  const alignClass = getContentAlignClass(column.contentAlign);

  const options = column.columnOptions || [];
  const optionsLoading = column.columnOptionsLoading === true;

  // Validar que value sea del tipo esperado por Dropdown
  const dropdownValue: string | number | (string | number)[] | undefined =
    value === undefined || value === null
      ? undefined
      : typeof value === 'string' || typeof value === 'number'
        ? value
        : Array.isArray(value) && value.every((v) => typeof v === 'string' || typeof v === 'number')
          ? (value as (string | number)[])
          : undefined;

  const hasFixedWidth = column.width !== undefined;
  return (
    <td
      className={cn(baseClasses, 'ui-overflow-visible')}
      {...cellProps}
      onClick={(e) => handleCellClick(e, onCellFocus)}
    >
      <div
        className={cn(
          'ui-flex ui-h-full ui-items-center ui-overflow-visible',
          alignClass,
          hasFixedWidth && 'ui-min-w-0',
        )}
      >
        <Dropdown
          field={{ size: 'sm', disabled: state === 'disabled' }}
          items={{ options }}
          values={{ value: dropdownValue }}
          events={{ onValueChange: onChange }}
          popover={{ absolute: true, popoverZIndex: 35 }}
          status={{ loading: optionsLoading }}
        />
      </div>
    </td>
  );
};
